module.exports = __webpack_public_path__ + "static/media/neutral.9f79380a.svg";